import * as RedirectUtils from './redirect-utils';

export default RedirectUtils;
